import React from "react";
import PropTypes from "prop-types";
import CandidatePageFooter from "./CandidatePageFooter";

function CandidatePageWrapper({ contentClassName, children, showFooter }) {
    return (
        <div className="flex flex-col flex-jsb h100">
            <div className={contentClassName}>{children}</div>
            {showFooter && <CandidatePageFooter />}
        </div>
    );
}

CandidatePageWrapper.propTypes = {
    contentClassName: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    showFooter: PropTypes.bool,
};

CandidatePageWrapper.defaultProps = {
    contentClassName: "checkin",
    showFooter: true,
};

export default React.memo(CandidatePageWrapper);
